import { useMemo } from "react";
import OvertimeDrawer from ".";
import { useVisible } from "../../../../../utils/hooks/useVisible"

export const useOvertimeDrawer = ({ isMyTimesheet = false }) => {
    const { visible, open, close, selected } = useVisible();
    const drawer = useMemo(() => {
        return visible ? (
            <OvertimeDrawer
                open={visible}
                close={close}
                values={selected}
                isMyTimesheet={isMyTimesheet}
            />
        ): null;
    }, [close, isMyTimesheet, selected, visible]);

    return { open, drawer };
}
